import React from "react";
import './webdevcontent.css';

const WebDevContent: React.FC = () => {
    return (
        <main>
            <header>
                <h1>Web Development Services</h1>
            </header>

            <section>
                <p>At Alvero Software Solutions, we specialize in creating exceptional websites that not only look great but also provide a seamless user experience. Our team of expert developers and designers is dedicated to helping small businesses establish a strong online presence through innovative web development solutions.</p>
            </section>

            <section>
                <h2>Our Web Development Services</h2>
                <h3>Custom Website Design</h3>
                <p>Visually stunning and highly functional websites that reflect your brand identity and engage your audience, tailored to meet your specific business needs and goals.</p>

                <h3>Responsive Design</h3>
                <p>Ensuring your website looks and performs beautifully on desktops, tablets, and smartphones with fully responsive designs.</p>

                <h3>E-commerce Solutions</h3>
                <p>Secure, user-friendly online stores with shopping cart integration, payment gateway setup, and inventory management for a smooth selling experience.</p>

                <h3>Content Management Systems (CMS)</h3>
                <p>Providing CMS solutions that allow easy management and updates of your website content, whether it's a simple blog or a complex content-heavy site.</p>

                <h3>SEO Optimization</h3>
                <p>Implementing SEO best practices to ensure your website ranks high in search engine results, increasing online visibility and traffic.</p>

                <h3>Website Maintenance and Support</h3>
                <p>Ongoing maintenance and support services to keep your website running smoothly, including regular updates, troubleshooting, and performance optimization.</p>
            </section>

            <section>
                <h2>Specialized Shopify and Square Services</h2>
                <h3>Shopify Services</h3>
                <ul>
                    <li>✅ Shopify store setup and customization</li>
                    <li>✅ Theme design and optimization</li>
                    <li>✅ App integration (payment, shipping, analytics)</li>
                    <li>✅ Product and inventory management</li>
                    <li>✅ Performance tuning and SEO for Shopify</li>
                </ul>

                <h3>Square Online Services</h3>
                <ul>
                    <li>✅ Square Online store and service booking setup</li>
                    <li>✅ Square Appointments configuration</li>
                    <li>✅ Payment integration and test environment setup</li>
                    <li>✅ Custom branding and mobile optimization</li>
                    <li>✅ Enhancements for existing Square systems</li>
                </ul>
                <p>Explore live demos on the Demo Page to see these solutions in action.</p>
            </section>

            <section>
                <h2>Why Choose Alvero Software Solutions?</h2>
                <ul>
                    <li><strong>Expert Team:</strong> Skilled developers and designers with years of industry experience.</li>
                    <li><strong>Client-Centric Approach:</strong> Tailored solutions aligned perfectly with business needs and goals.</li>
                    <li><strong>Innovative Solutions:</strong> Leveraging the latest technologies and best practices to create standout websites.</li>
                    <li><strong>Affordable Services:</strong> Competitively priced web development services providing maximum value.</li>
                </ul>
            </section>

            <section>
                <h2>Our Process</h2>
                <ol>
                    <li><strong>Consultation:</strong> Understanding your business, goals, and requirements through in-depth consultations.</li>
                    <li><strong>Planning:</strong> Crafting a detailed plan outlining scope, timeline, and deliverables.</li>
                    <li><strong>Design:</strong> Creating design mockups and prototypes for visualization before development begins.</li>
                    <li><strong>Development:</strong> Bringing the vision to life using the latest technologies and best practices.</li>
                    <li><strong>Testing:</strong> Rigorous testing to ensure reliability, security, and launch readiness.</li>
                    <li><strong>Deployment:</strong> Assisting with website deployment and ensuring smooth functionality.</li>
                    <li><strong>Support:</strong> Providing ongoing support and maintenance for continuous success.</li>
                </ol>
            </section>

            <section>
                <h2>Contact Us</h2>
                <p>Ready to build a stunning website or enhance your existing Shopify or Square system? Contact Alvero Software Solutions today to discuss your web development needs and get started on your project.</p>
            </section>
        </main>
    )
};

export default WebDevContent;
